import React from "react";
import image_2 from "../../images/agriculture/Picture14.webp";
import image_1 from "../../images/agriculture/Picture2.webp";

const DatesGrower = () => {
  return (
    <section id="dates-grower">
      <div className="dates-grower-container">
        <div className="ms-13 me-13 pt-7 pb-7 text-center">
          <img src={image_1} className="img-fluid" alt="" />
          <h1 className="fs-56 lh-64 text-uppercase gilroy-bold text-white pt-5">
            Dates Grower
          </h1>
        </div>
      </div>
      <div className="bg-chinese-black text-white">
        <div className="ms-47 me-47 pt-7 pb-7">
          <div className="row">
            <div className="col-lg-8 col-xl-8">
              <h1 className="fs-56 lh-64 gilroy-bold text-orange-ryb pb-5">
                Our Farms
              </h1>
              <p className="fs-20 lh-30 text-align-justify">
                Our organic date farms are nestled in a fertile oasis in the Al
                Wahet region of EGYPT, north of the Nile. Here, by the historic
                green valleys of the Nile Valley, over 100,000 date palm trees
                grow, basking in the temperate climate and naturally flowing
                sweet water for irrigation. This unique terroir lends to the
                inimitable taste of every SEGAM dates.
              </p>
              <h2 className="fs-28 gilroy-bold text-orange-ryb py-5">
                Sustainable Farming
              </h2>
              <p className="fs-20 lh-30 text-align-justify">
                Using the best farming practices, SEGAM’s cultivation techniques
                are kept as close to nature as possible. Date palm trees can
                live as long as a century and produce up to 150 kilograms of
                fruit each year.
              </p>
              <p className="fs-20 lh-30 text-align-justify">
                Every date palm is watered from the naturally occurring desert
                wadi, transforming the landscape into a fertile reserve. Our
                strategically placed irrigation system is channeled across the
                farm to enable farmers to recycle and preserve the readily
                available water of the land.
              </p>
              <p className="fs-20 lh-30 text-align-justify">
                SEGAM groves produce nearly 2,000 tonnes of organic waste per
                year, all of which is returned to the farm as nutrient-rich
                compost. We take great pride in our overarching organic ethos
                and continue to innovate, using unique sustainable methods for
                abundant yields.
              </p>
            </div>
            <div className="col-lg-4 col-xl-4">
              <div className="d-flex align-items-center justify-content-center h-100">
                <img src={image_2} className="dates-grower-img" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DatesGrower;
